import { memo, useLayoutEffect, useState } from 'react';

import { Config } from '@bonanza-social/toolkit/config';
import useBreakpointProp from '../../hooks/useBreakpointProp';
import Image from '../../common/Image/Image';
import { ImageProps, ImageStyle } from '../../common/Image/Image.types';

Image.prefetch(`${Config.LOBBY_BACKGROUND_IMAGE_URL}?Type=Mobile`);

function BackgroundImage() {
  const type = useBreakpointProp({
    mobile: 'Mobile',
    tablet: 'Desktop',
    desktop: 'Desktop',
  });
  const [imgProps, setImgProps] = useState<ImageProps<ImageStyle>>({});

  const onErrorHandler = () => {
    setImgProps({ name: 'common.homePageBackground' });
  };

  useLayoutEffect(() => {
    // Done for backwards compatibility with OTA update
    // The value from config would be the old one with the query param
    const configUrl = Config.LOBBY_BACKGROUND_IMAGE_URL;
    let url = configUrl;

    if (configUrl.match(/\?/)) {
      url = configUrl.split('?')[0];
    }

    setImgProps({
      source: `${url}?Type=${type}`,
    });
  }, [type]);

  return (
    <Image
      {...imgProps}
      onError={onErrorHandler}
      alt="background-img"
      contentFit="cover"
      width="100%"
      height="100%"
      position="absolute"
      cachePolicy="memory-disk"
      recyclingKey={type}
    />
  );
}

export default memo(BackgroundImage);
